class ProductCard extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('.color-swatch').forEach((s) => s.addEventListener('click', this.onSwatchClick.bind(this)));
  }

  onSwatchClick(event) {
    const swatch = event.target;
    const productImage = this.querySelector(`[data-product-image="${this.dataset.productId}"]`);
    const swatchImageElement = swatch.querySelector('.data-variant-image');
    let newImageUrl = swatchImageElement ? swatchImageElement.getAttribute('src') : null;
    let newSrcset = swatchImageElement ? swatchImageElement.getAttribute('srcset') : null;
    if(newImageUrl === null) {
      newImageUrl = swatch ? swatch.getAttribute('src') : null ;
      newSrcset = swatch ? swatch.getAttribute('srcset') : null;
    }
    this.querySelectorAll('.color-swatch').forEach((s) => s.classList.remove('selected'));
    swatch.classList.add('selected');

    if (productImage && newImageUrl) {
      productImage.src = newImageUrl;
      productImage.srcset = newSrcset;
    }
  }
}

// Ajax Cart Product Form for liquid-ajax-cart compatibility
class AjaxCartProductForm extends HTMLElement {
  connectedCallback() {
    // This custom element allows liquid-ajax-cart to recognize and process the forms
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}

if (!customElements.get('ajax-cart-product-form')) {
  customElements.define('ajax-cart-product-form', AjaxCartProductForm);
}

// Handle cart updates and trigger drawer opening
function handleCartUpdate(event) {
  const { requestState } = event.detail;
  
  // Check if this was a successful add to cart operation
  if (requestState.requestType === 'add' && requestState.responseData?.ok) {
    // Add CSS class for cart display
    document.body.classList.add('js-show-ajax-cart');
    
    // Dispatch custom event for cart drawer
    document.dispatchEvent(new CustomEvent('item-added-to-cart', {
      detail: requestState.responseData.body
    }));
  }
}

// Listen for liquid-ajax-cart events
document.addEventListener('liquid-ajax-cart:request-end', handleCartUpdate);